// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosurattransport() {



const cardData = {


    keyword: "Pune to Surat Transport Service",

    headingDescription: "SSK Logistic provides organized Pune to Surat Transport Service solutions for businesses requiring dependable road movement of commercial goods, industrial materials, machinery, inventory, cargo, and full truck load consignments between Maharashtra and Gujarat. The transportation service is suitable for manufacturers, distributors, traders, warehouses, suppliers, and businesses handling regular interstate shipments. SSK Logistic supports different cargo requirements through suitable truck arrangements, loading coordination, freight planning, and route-focused transportation. Businesses can use these Pune to Surat transportation solutions for factory-to-factory movement, warehouse transfers, distributor deliveries, commercial inventory transportation, industrial supply requirements, and other road freight needs connecting Pune with Surat and surrounding Gujarat business destinations.",

    topPlaces: [
        {
            title: "Surat",
            description: "Surat is a major commercial and industrial destination in Gujarat with strong requirements for transportation of textiles, machinery, packaged products, commercial inventory, raw materials, and other business cargo. SSK Logistic supports Pune-origin shipments toward Surat through organized road transportation and suitable truck arrangements."
        },
        {
            title: "Hazira",
            description: "Hazira is an important industrial and port-linked area near Surat where businesses require regular transportation of industrial materials, equipment, machinery, components, and commercial consignments. Pune to Hazira movement can be coordinated according to cargo volume, vehicle requirements, and loading conditions."
        },
        {
            title: "Bharuch",
            description: "Bharuch is a significant industrial destination on the Gujarat corridor and is connected with several manufacturing and commercial supply chains. SSK Logistic can support transportation from Pune toward Bharuch for suitable industrial goods, machinery, packaged materials, and business freight."
        },
        {
            title: "Pune to Ahmedabad",
            description: "Pune to Ahmedabad is an important interstate commercial route connecting Maharashtra with Gujarat's major business center. Transportation requirements can include manufactured goods, industrial supplies, machinery, inventory transfers, commercial cargo, and full truck load consignments."
        },
        {
            title: "Ankleshwar",
            description: "Ankleshwar is a well-known industrial location in Gujarat with transportation demand for manufacturing supplies, machinery, components, packaged goods, and other commercial consignments. Pune-origin shipments can be arranged for businesses requiring road freight connectivity with this industrial region."
        },
        {
            title: "Vapi",
            description: "Vapi is an established industrial hub in southern Gujarat and a relevant destination for Maharashtra-based supply chains. SSK Logistic supports Pune to Vapi transportation requirements involving industrial materials, commercial goods, equipment, finished products, and warehouse consignments."
        },
        {
            title: "Pune to Vadodara",
            description: "Pune to Vadodara transportation supports commercial and industrial businesses moving goods into central Gujarat. Shipments may include machinery, manufacturing components, packaged products, raw materials, business inventory, and full-load cargo requiring organized road transportation."
        },
        {
            title: "Navsari",
            description: "Navsari is an important commercial destination near Surat where businesses may require movement of packaged goods, commercial inventory, machinery, and other suitable cargo. Pune-origin transportation can be coordinated for regular and one-time shipment requirements."
        },
        {
            title: "Pune to Rajkot",
            description: "Pune to Rajkot provides a wider Gujarat connection for businesses transporting industrial and commercial goods beyond Surat. SSK Logistic can support road freight requirements involving machinery, equipment, manufactured products, spare parts, packaged cargo, and larger business consignments."
        },
        {
            title: "Palsana",
            description: "Palsana is an industrial and logistics-oriented area near Surat with businesses requiring transportation for manufacturing supplies, commercial products, machinery, and inventory. Pune to Palsana movement can support supply-chain requirements connected with Surat's wider industrial region."
        }
    ],

    "services": [
        {
            "name": "pune to surat transport service",
            "description": "SSK Logistic handles Pune to Surat transport service requirements for businesses moving commercial goods, industrial materials, machinery, inventory, and regular consignments between Maharashtra and Gujarat. Transportation planning can be aligned with cargo volume, vehicle capacity, loading requirements, and delivery schedules."
        },
        {
            "name": "pune to surat transportation service",
            "description": "The Pune to Surat transportation service supports businesses requiring structured road movement between manufacturing, warehouse, distribution, and commercial locations. SSK Logistic coordinates suitable transportation arrangements for different shipment sizes and business logistics requirements."
        },
        {
            "name": "pune surat goods transport",
            "description": "Pune Surat goods transport is suitable for moving manufactured products, commercial inventory, raw materials, machinery, packaged goods, and other business consignments. SSK Logistic assists with vehicle planning and road transportation according to the nature and quantity of the shipment."
        },
        {
            "name": "pune to surat goods transportation",
            "description": "Pune to Surat goods transportation provides businesses with organized road connectivity for warehouse transfers, factory shipments, distributor stock, commercial products, and industrial materials. Transportation can be planned around cargo dimensions, volume, vehicle capacity, and destination requirements."
        },
        {
            "name": "pune to surat cargo transport",
            "description": "Pune to Surat cargo transport supports businesses moving packaged products, industrial supplies, equipment, machinery, inventory, and other commercial cargo. SSK Logistic coordinates route-focused transportation arrangements for one-time as well as recurring cargo movement requirements."
        },
        {
            "name": "pune to surat freight transport",
            "description": "Pune to Surat freight transport is designed for businesses managing regular or bulk freight across the Maharashtra-Gujarat corridor. SSK Logistic supports truck-based movement of industrial materials, finished goods, commercial consignments, and warehouse-to-warehouse freight."
        },
        {
            "name": "pune to surat logistics service",
            "description": "The Pune to Surat logistics service helps businesses organize interstate road transportation for ongoing supply-chain requirements. SSK Logistic supports cargo planning, truck coordination, loading arrangements, dispatch scheduling, and destination delivery planning for commercial and industrial shipments."
        },
        {
            "name": "pune surat transport company",
            "description": "Businesses searching for a Pune Surat transport company can use SSK Logistic for structured road freight requirements connecting Pune with Surat and nearby industrial destinations. The service supports commercial goods, machinery, inventory, industrial supplies, and full-load consignments."
        },
        {
            "name": "pune to surat truck transport",
            "description": "Pune to Surat truck transport provides businesses with dedicated road movement for commercial and industrial shipments. SSK Logistic can coordinate appropriate truck capacity for machinery, packaged products, raw materials, inventory, equipment, and larger business consignments."
        },
        {
            "name": "pune to surat full truck load transport",
            "description": "Pune to Surat full truck load transport is suitable when a business needs dedicated vehicle capacity for a larger shipment. SSK Logistic supports FTL movement for factory materials, finished goods, machinery, inventory transfers, industrial products, and other high-volume consignments."
        },
        {
            "name": "pune to surat container transport",
            "description": "Pune to Surat container transport supports businesses requiring enclosed or containerized road movement for suitable commercial and industrial cargo. SSK Logistic coordinates container transportation according to shipment volume, cargo characteristics, loading requirements, and destination conditions."
        },
        {
            "name": "pune to surat commercial transport",
            "description": "Pune to Surat commercial transport is designed for companies moving inventory, packaged products, business materials, machinery, and commercial consignments. SSK Logistic provides route-focused transportation coordination for regular dispatches, warehouse transfers, and one-time commercial shipments."
        },
        {
            "name": "pune to surat industrial transport",
            "description": "Pune to Surat industrial transport supports manufacturers and industrial businesses moving machinery, components, raw materials, production supplies, equipment, and finished goods. SSK Logistic can coordinate suitable vehicle arrangements according to cargo dimensions, quantity, and transportation requirements."
        },
        {
            "name": "pune to surat cargo transportation",
            "description": "Pune to Surat cargo transportation provides road-based movement for businesses transferring goods between factories, warehouses, distributors, and commercial destinations. SSK Logistic supports cargo planning for packaged goods, industrial materials, equipment, machinery, and regular business consignments."
        },
        {
            "name": "pune to surat freight services",
            "description": "Pune to Surat freight services are useful for companies requiring planned movement of commercial and industrial freight across Maharashtra and Gujarat. SSK Logistic supports freight coordination, truck selection, loading planning, dispatch arrangements, and destination-oriented transportation."
        },
        {
            "name": "pune to surat goods transport company",
            "description": "A Pune to Surat goods transport company helps businesses coordinate recurring and one-time shipments across the interstate road network. SSK Logistic handles suitable transportation requirements for commercial inventory, industrial supplies, machinery, packaged products, and business goods."
        },
        {
            "name": "pune to surat transport company",
            "description": "Pune to Surat transport company services from SSK Logistic are structured around business-focused road transportation needs. Companies can arrange suitable truck movement for factory shipments, warehouse transfers, commercial cargo, industrial materials, and full-load consignments."
        },
        {
            "name": "pune to surat transporters",
            "description": "Businesses looking for Pune to Surat transporters can coordinate road freight movement with SSK Logistic according to shipment size and delivery requirements. Transportation options can support commercial cargo, industrial consignments, machinery, inventory, packaged products, and regular supply-chain movements."
        },
        {
            "name": "pune to surat logistics provider",
            "description": "A Pune to Surat logistics provider supports businesses that need organized transportation between production centers, warehouses, distributors, and commercial destinations. SSK Logistic coordinates road freight requirements with attention to cargo volume, vehicle suitability, dispatch planning, and delivery coordination."
        },
        {
            "name": "pune to surat road transport",
            "description": "Pune to Surat road transport provides direct interstate connectivity for commercial and industrial cargo. SSK Logistic supports truck-based movement of goods, equipment, materials, and business inventory while coordinating transportation according to shipment size, route, and destination requirements."
        },
        {
            "name": "pune to surat safe goods transport",
            "description": "Pune to Surat safe goods transport focuses on organized handling and suitable vehicle arrangements for business consignments. SSK Logistic supports planned loading, route coordination, and delivery scheduling for commercial goods, industrial materials, equipment, and other suitable cargo."
        },
        {
            "name": "pune to surat reliable transport service",
            "description": "The Pune to Surat reliable transport service from SSK Logistic is intended for businesses that need consistent coordination for interstate goods movement. It can support recurring dispatches, warehouse transfers, industrial shipments, commercial cargo, and full-load transportation requirements."
        },
        {
            "name": "pune to surat truck booking",
            "description": "Pune to Surat truck booking helps businesses arrange suitable road transportation according to cargo volume, dimensions, and vehicle requirements. SSK Logistic can coordinate truck options for full loads, industrial materials, machinery, commercial inventory, and other suitable shipments."
        },
        {
            "name": "pune to surat cargo booking",
            "description": "Pune to Surat cargo booking supports businesses planning interstate shipments from Pune toward Surat and connected Gujarat destinations. SSK Logistic assists with cargo transportation arrangements based on shipment type, quantity, loading requirements, vehicle capacity, and delivery location."
        }
    ],

    "tableData": [
        ["pune to surat transport service", "pune to surat transportation service"],
        ["pune surat goods transport", "pune to surat goods transportation"],
        ["pune to surat cargo transport", "pune to surat freight transport"],
        ["pune to surat logistics service", "pune surat transport company"],
        ["pune to surat truck transport", "pune to surat full truck load transport"],
        ["pune to surat container transport", "pune to surat commercial transport"],
        ["pune to surat industrial transport", "pune to surat cargo transportation"],
        ["pune to surat freight services", "pune to surat goods transport company"],
        ["pune to surat transport company", "pune to surat transporters"],
        ["pune to surat logistics provider", "pune to surat road transport"],
        ["pune to surat safe goods transport", "pune to surat reliable transport service"],
        ["pune to surat truck booking", "pune to surat cargo booking"],
        ["Pune to Surat Transport Service", "Pune Surat Commercial & Industrial Goods Movement"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Dedicated Pune Surat Route Support",
            WhyChoosedescription: "SSK Logistic focuses on road transportation requirements between Pune and Surat, helping businesses coordinate interstate movement of commercial goods, industrial materials, machinery, inventory, and regular freight consignments."
        },
        {
            WhyChooseheading: "Transportation for Different Shipment Sizes",
            WhyChoosedescription: "Cargo requirements can vary significantly between businesses, so transportation planning can be aligned with shipment quantity, dimensions, loading conditions, and vehicle capacity to support suitable movement."
        },
        {
            WhyChooseheading: "Industrial Freight Coordination",
            WhyChoosedescription: "Manufacturing and industrial businesses can use the service for transporting machinery, components, production supplies, raw materials, and finished products between Pune-based operations and Surat or nearby Gujarat industrial locations."
        },
        {
            WhyChooseheading: "Commercial Cargo Movement",
            WhyChoosedescription: "Commercial inventory, packaged products, distributor stock, warehouse transfers, and business materials can be coordinated through structured road transportation arrangements suited to both recurring and one-time dispatch requirements."
        },
        {
            WhyChooseheading: "Full Load Truck Options",
            WhyChoosedescription: "Larger consignments requiring dedicated vehicle capacity can be planned through full truck load transportation arrangements, with attention to cargo volume, loading requirements, route suitability, and destination delivery coordination."
        },
        {
            WhyChooseheading: "Connected Gujarat Destinations",
            WhyChoosedescription: "Beyond Surat, the wider transportation network can connect businesses with relevant Gujarat destinations such as Hazira, Bharuch, Ankleshwar, Vapi, Vadodara, and other commercial or industrial locations according to shipment requirements."
        },
        {
            WhyChooseheading: "Planned Truck and Cargo Booking",
            WhyChoosedescription: "Businesses can coordinate truck and cargo booking around shipment type, quantity, vehicle capacity, loading needs, destination, and preferred transportation schedule for more organized interstate goods movement."
        },
        {
            WhyChooseheading: "Supply Chain Transportation Assistance",
            WhyChoosedescription: "SSK Logistic supports manufacturers, distributors, warehouses, traders, and commercial businesses that require organized movement of goods between Pune, Surat, and connected industrial regions as part of their regular supply-chain operations."
        }
    ]

};




















const faqData = [
    {
        question: "What does SSK Logistic provide for Pune to Surat transport service?",
        answer: "SSK Logistic assists businesses with interstate goods transportation from Pune to Surat, arranging suitable commercial vehicles according to the cargo type, shipment quantity, weight, loading requirements, pickup location, delivery point, and preferred schedule."
    },
    {
        question: "Can SSK Logistic transport commercial goods from Pune to Surat?",
        answer: "Commercial inventory, packaged products, raw materials, machinery, equipment, manufacturing components, business supplies, and other suitable cargo can be transported from Pune to Surat based on the shipment specifications and handling requirements."
    },
    {
        question: "Can industrial materials be transported from Pune to Surat?",
        answer: "Industrial materials, machinery, equipment, components, and other suitable manufacturing-related goods can be considered for Pune to Surat transportation after reviewing their weight, dimensions, loading conditions, and required vehicle capacity."
    },
    {
        question: "Does SSK Logistic provide regular Pune to Surat transportation?",
        answer: "Businesses with recurring shipment requirements can discuss regular transportation arrangements based on movement frequency, cargo volume, pickup locations, delivery points, vehicle requirements, and their preferred operating schedule."
    },
    {
        question: "Which Pune areas can be covered for Surat-bound shipments?",
        answer: "Pickup arrangements can be discussed from commercial and industrial locations across Pune, including Chakan, Bhosari, Pimpri-Chinchwad, Talegaon, Ranjangaon, Hinjewadi, Hadapsar, and other nearby business areas."
    },
    {
        question: "What type of vehicle is suitable for Pune to Surat goods transport?",
        answer: "The appropriate vehicle depends on cargo weight, dimensions, quantity, loading method, material characteristics, and delivery requirements. SSK Logistic can review the shipment details and discuss suitable commercial vehicle arrangements."
    },
    {
        question: "Can warehouse-to-warehouse goods movement be arranged between Pune and Surat?",
        answer: "Warehouse-to-warehouse transportation can be coordinated for companies transferring inventory, finished products, raw materials, equipment, or other business cargo between warehouses, distribution centers, factories, and commercial locations."
    },
    {
        question: "Can bulk cargo be transported from Pune to Surat through SSK Logistic?",
        answer: "Bulk transportation requirements can be discussed by sharing the total cargo quantity, approximate weight, number of consignments, Pune loading location, Surat delivery address, vehicle requirement, and preferred movement schedule."
    },
    {
        question: "How does SSK Logistic plan Pune to Surat interstate transportation?",
        answer: "Transportation planning considers the pickup and delivery addresses, cargo type, shipment quantity, weight and dimensions, loading conditions, vehicle capacity, route requirements, and desired delivery timeline to organize the movement appropriately."
    },
    {
        question: "What details are required for a Pune to Surat transport enquiry?",
        answer: "Businesses can provide the Pune pickup address, Surat delivery location, cargo description, approximate weight or quantity, dimensions if applicable, loading details, vehicle preference, and expected pickup or delivery schedule for transportation planning."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Harish Mehta",
        feedback: "Our company needed to move commercial stock from Pune to Surat for distribution. SSK Logistic reviewed the shipment quantity and transportation requirements carefully and helped coordinate the movement in line with our business schedule.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Pooja Shinde",
        feedback: "We arranged transportation for manufacturing supplies from Pune to Surat and wanted clear coordination throughout the process. The SSK Logistic team understood our cargo details and vehicle needs, making the interstate shipment easier to manage.",
        rating: 5
    }
];








    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Surat Transport Service",
  "image": "https://ssklogistics.in/assets/images/pune-to-surat-transport-service.webp",
  "description": "SSK Logistics provides Pune to Surat Transport Service for businesses requiring dependable interstate movement of goods, cargo, freight and commercial consignments between Pune and Surat. Pune to Surat transport service can support manufacturers, distributors, wholesalers, retailers, warehouses and industrial businesses that require regular, scheduled or project-based transportation between Maharashtra and Gujarat. Pune to Surat transportation service can be coordinated according to cargo type, shipment volume, vehicle capacity, pickup requirements and delivery schedules. Pune Surat goods transport can cover commercial products, industrial materials, packaged goods, machinery, equipment, inventory and other business consignments. Pune to Surat goods transportation can support supplier deliveries, warehouse transfers, distribution movements and recurring business shipments along the route. Pune to Surat cargo transport is suitable for commercial and industrial cargo requiring organized road transportation, while Pune to Surat freight transport can accommodate larger consignments and recurring business freight requirements. Pune to Surat logistics service can include vehicle coordination, route planning, pickup scheduling and delivery coordination based on individual shipment requirements. As a Pune Surat transport company, SSK Logistics can arrange suitable transportation solutions for businesses requiring dedicated vehicles and planned cargo movement between the two cities. The service can connect factories, warehouses, suppliers, distribution centers and customer destinations across Pune, Surat and other locations along the transportation network. SSK Logistics focuses on flexible interstate transportation arrangements designed around cargo specifications, business schedules and destination requirements for organized Pune to Surat goods, cargo and freight movement.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Transport Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/pune-to-surat-transport-service"
  }
};







    return (
        <div>


<Helmet>
  <title>
    Pune to Surat Transport Service | Goods, Cargo, Freight & Logistics Transportation | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics provides Pune to Surat transport services for goods, cargo and freight with coordinated interstate transportation solutions for commercial and industrial shipments."
  />

  <meta
    name="keywords"
    content="Pune to Surat Transport Service, Pune to Surat transport service, Pune to Surat transportation service, Pune Surat goods transport, Pune to Surat goods transportation, Pune to Surat cargo transport, Pune to Surat freight transport, Pune to Surat logistics service, Pune Surat transport company, Pune Surat transportation service, Pune Surat goods transportation, Pune Surat cargo transportation, Pune Surat freight services, Pune to Surat transport company, Pune to Surat goods transport company, Pune to Surat cargo transport company, Pune to Surat freight transportation, Pune to Surat logistics company, Pune Surat logistics services, Pune Surat commercial transport, Pune Surat commercial goods transport, Pune Surat industrial transport, Pune Surat industrial goods transportation, Pune Surat truck transport, Pune Surat truck transportation, Pune Surat full truck load transport, Pune to Surat FTL transport, Pune Surat cargo services, Pune Surat goods transportation services, Pune Surat freight transportation services, Pune Surat road transport, Pune to Surat road transportation, Pune Surat business transport, Pune Surat warehouse transport, Pune Surat interstate transport services, Pune Surat commercial logistics, Pune Surat supply chain transportation, Maharashtra to Gujarat transport service, Pune Gujarat goods transportation, Pune Surat dedicated truck transport, Pune Surat dedicated transportation"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosurattransport;